import { useState, useEffect } from 'react';
import { SelectMenu } from '@hakimo-ui/hakimo/ui-elements';
import { Selectable } from '@hakimo-ui/shared/ui-base';
import {
  displayAlarmTypeValue,
  createSOPAlarmTypeChangeHandler,
} from '../utils';

interface Props {
  onChange: (alarmType: Selectable | null) => void;
  initialAlarmTypeId?: string;
  sopAlarmTypes?: Selectable[];
}

const DEFAULT_SOP_OPTION: Selectable = {
  id: 'default',
  name: 'Default SOP',
};

export function SOPAlarmTypeSelector(props: Props) {
  const { onChange, initialAlarmTypeId, sopAlarmTypes = [] } = props;
  const [selectedAlarmType, setSelectedAlarmType] =
    useState<Selectable>(DEFAULT_SOP_OPTION);

  useEffect(() => {
    if (initialAlarmTypeId && sopAlarmTypes.length > 0) {
      const matchingType = sopAlarmTypes.find(
        (type) => type.id === initialAlarmTypeId
      );
      if (matchingType) {
        setSelectedAlarmType(matchingType);
      }
    } else {
      setSelectedAlarmType(DEFAULT_SOP_OPTION);
    }
  }, [initialAlarmTypeId, sopAlarmTypes]);

  const allItems = [DEFAULT_SOP_OPTION, ...sopAlarmTypes];

  const onChangeAlarmType = createSOPAlarmTypeChangeHandler(
    setSelectedAlarmType,
    onChange
  );

  return (
    <div>
      <SelectMenu
        label=""
        items={allItems}
        value={selectedAlarmType}
        onChange={onChangeAlarmType}
        displayValue={displayAlarmTypeValue}
        placeholder="Select an alarm type"
        id={(item) => item.id}
      />
    </div>
  );
}

export default SOPAlarmTypeSelector;
